import Rating from '../../../../../component/rating/Rating.component';
import { FormInputMultiline } from '../../../../../component/input/InputStyle';
import FormLabel from '../../../../../component/input/FormLabel.component';
import { ChangeEvent, useState,  useEffect } from 'react';
import ButtonForm from '../../../../../component/buttton/ButtonForm.component';
import { useParams } from 'react-router-dom';
import ParamTypes from '../../../../../core/interfaces/ParamTypes';
import { getUser } from './../../../../../core/auth/auth';
import { getRatingQuestion, getRatingComment, updateRatingComment, updateAssesment, createRatingComment } from '../../Details.service';
import { RatingQuestionInterface } from '../interface/RatingQuestionInterface';
import { CommentInterface } from '../interface/AssesmentInterface';
import Progress from '../../../../../component/progress/Progress.component';
import { useHistory  } from "react-router-dom";
import ModalConfirm from '../component/ModalConfirm';
import useModal from './../../../../../hooks/useModal';
import { useStore } from '../../../../../context/Store';
import RatingNPS from '../../../../../../src/component/rating/RatingNPS.component';


interface ICommentSubmit {
  idUsuario: string,
  dtComentario: Date,
  flConfirmaResposta: boolean,
  flConfirmaLeitura: boolean,
  dtLeitura: Date,
  dsComentario: string,
  idAvaliacao: string
}

export default function Answer() {

  const history = useHistory();
  const { assesmentList, setAssesmentList } = useStore();

  let { id, idAssesment } = useParams<ParamTypes>();
  const [values, setValues] = useState<any>();
  const [ratingComment, setRatingComment] = useState<CommentInterface[]>([]);
  const [ratingQuestion, setRatingQuestion] = useState<RatingQuestionInterface[]>([])
  const [ratingQuestionNPS, setRatingQuestionNPS] = useState<RatingQuestionInterface[]>([])
  const [load, setLoad] = useState(true);
  const [open, addModal] = useModal();
  const [userComment, setUserComment] = useState<CommentInterface[]>([]);
  const [managerComment, setManagerComment] = useState<CommentInterface[]>([]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setValues(value);
  }

  const handleSubmit = async () => {
    setLoad(true);
    const userInfo = await getUser();

    const data:ICommentSubmit = {
      idUsuario: userInfo.sAMAccountName,
      dtComentario: new Date(),
      flConfirmaResposta: true,
      flConfirmaLeitura: true,
      dtLeitura: new Date(),
      dsComentario: values,
      idAvaliacao: idAssesment
    }

    try {
      const updateComment = ratingComment.map((comment:CommentInterface) => {
         comment.flConfirmaResposta = true;
         return comment;
      });

      updateComment.map((comment) => {
        updateRatingComment(comment.id, comment).then(() => {
          setTimeout(async() => {
              const assesment = {flAvaliadoLoja:true};
              await updateAssesment(idAssesment, assesment).then(() => {
                  setTimeout(async() => {
                    await createRatingComment(data);
                    setLoad(false);
                    addModal(true)
                }, 1.5*1000)
              })
          }, 1.5*1000)
        })
      })

  } catch(err) {
      console.log("Erro!!", err)
  }
  }

  const onChange = (value?: number | null) => {
    console.log(value)
  }

  const getAvaliations = async () => {
    try {
      const userInfo = await getUser();

      const getQuestion = await getRatingQuestion().then((data) => data);

      const question = getQuestion.data.filter((data:RatingQuestionInterface) => data.idAvaliacao?.id === idAssesment && !data.idPerguntaPesquisa.flNPS)
                .sort((x:RatingQuestionInterface, y:RatingQuestionInterface) => {
                    return (x.idPerguntaPesquisa.dsPesquisa.length - y.idPerguntaPesquisa.dsPesquisa.length)
                })

      const questionNPS = getQuestion.data.filter((data:RatingQuestionInterface) => data.idAvaliacao?.id === idAssesment && data.idPerguntaPesquisa.flNPS);

      setTimeout(async () => {
        const getComment = await getRatingComment().then((data) => data);

        const comment = getComment.data.filter((data:CommentInterface) => data.idAvaliacao?.id === idAssesment)

        setUserComment(comment.filter((data:CommentInterface) => data.idUsuario !== userInfo.sAMAccountName))

        setManagerComment(comment.filter((data:CommentInterface) => data.idUsuario === userInfo.sAMAccountName))

        const confirmRead = comment.filter((data:CommentInterface) => data.flConfirmaLeitura === false)
        .map((data:CommentInterface) => {
            data.flConfirmaLeitura = true;
            return data;
        })

        confirmRead.map((comment:CommentInterface) => {
          updateRatingComment(comment.id, comment);
        });

        setRatingComment(comment)
        setRatingQuestion(question);
        setRatingQuestionNPS(questionNPS);

        setLoad(false);
      }, 1000*1.5);

    } catch(err) {
      console.log("Error: ",err);
    }
  }

  const confirmModal = () => {
    addModal(!open)
    setTimeout(() => {
      history.push(`/loja/${id}/avaliacao`);
    }, 1000*1.0)

  }

  useEffect(() => {
    getAvaliations();
  },[])

  return (
    <>
      <ModalConfirm  open={!!open} handleClick={() => addModal('')} onClickSubmit={confirmModal} title="Resposta gravada com sucesso!" />
      {load === true ? <Progress  open={load} /> : (
        <>
          {ratingQuestion.map((question) => <Rating title={question.idPerguntaPesquisa.dsPesquisa} onChange={onChange} IconContainerComponent={question.idPerguntaPesquisa.flNPS} assesment={parseInt(question.vlrPesquisa)} />)}
          {ratingQuestionNPS.map((question) => <RatingNPS title={question.idPerguntaPesquisa.dsPesquisa} data={question.vlrPesquisa} />)}

          <FormLabel title="Comentário" sm={12}>
            <FormInputMultiline
              name="NumeroLoja"
              value={userComment[0].dsComentario}
              onChange={() => {}}
              disabled={true}
            />
          </FormLabel>

          <br />

          <FormLabel title="Sua resposta" sm={12} required>
            <FormInputMultiline
              name="NumeroLoja"
              value={managerComment.length > 0 ? managerComment[0].dsComentario : values}
              onChange={handleChange}
              disabled={managerComment.length > 0 ? true : false}
            />
          </FormLabel>

          <ButtonForm title='Salvar resposta'onClick={() => handleSubmit()} link={`/loja/${id}/avaliacao`} disabled={managerComment.length > 0 ? true : false} />
        </>
      )}


    </>
  )
}
